import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import {
  PageHeader,
  SimpleDataTable,
  Section,
  ExpandableTextSection,
  toLineItem,
  makeBreadcrumb
} from '@budget-monorepo/shared-ui';

import Layout from '../components/Layout';
import AppropriationFilter from '../components/AppropriationFilter';
import HelmetData from '../components/HelmetData';

const LineItem = (props) => {
  const { location, data } = props;
  const { content, site } = data;
  const {
    govLevelOne, govLevelTwo, govLevelThree, lineItemNumber, parent: { parent }
  } = content;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = parent;
  const path = location.pathname;
  const pathPrefix = process.env.GATSBY_PATH_PREFIX;
  const relPath = path.replace(pathPrefix, '');
  const { pageTitle, breadcrumbprops } = makeBreadcrumb({
    href: '/appropriations',
    text: 'Appropriations',
    sections: govLevelOne === govLevelTwo ? [govLevelOne, govLevelThree, lineItemNumber] : [govLevelOne, govLevelTwo, govLevelThree, lineItemNumber]
  });

  const layoutProps = {
    activeIndex: 1,
    pre: () => <AppropriationFilter path={relPath} />,
    above: () => <PageHeader category={toLineItem(content.lineItemNumber)} title={content.lineItemName} />,
    pageTitle: toLineItem(pageTitle),
    breadcrumbprops,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  // metadata for the page
  const metaTitle = `${content.lineItemNumber}: ${content.lineItemName}`;
  const metaDescription = `View ${content.lineItemName} spending and appropriation data.`;
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        metaType: 'dataset',
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        <Section>
          {content.lineItemLanguage && <ExpandableTextSection text={content.lineItemLanguage} minHeight={200} htmlTag="div" />}
          {content.spendingCategory
            ? (
              <React.Fragment>
                <h3>{content.spendingCategory.title}</h3>
                <SimpleDataTable title={`${content.lineItemNumber} ${content.lineItemName} ${content.spendingCategory.title}`} table={content.spendingCategory} maxColWidth={100} download={location.pathname} />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <SimpleDataTable
                  title={`${content.lineItemNumber} ${content.lineItemName}`}
                  table={{
                    headers: [{
                      name: 'FY2021 Budgetary Recommendation',
                      type: 'currency',
                      align: 'right',
                      value: 'fyHouse'
                    }],
                    data: [{
                      fyHouse: content.nextFYspending
                    }]
                  }}
                  maxColWidth={100}
                />
              </React.Fragment>
            )
          }
        </Section>
      </Layout>
    </Fragment>
  );
};

LineItem.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
  location: PropTypes.object
};

export default LineItem;

export const query = graphql`
  query($slug: String!) {
    site {
      ...SiteMetadata
    }
    content: lineItem(fields: { slug: { eq: $slug } }) {
      lineItemNumber
      lineItemName
      lineItemLanguage
      govLevelOne
      govLevelTwo
      govLevelThree
      nextFYspending
      spendingCategory {
        title
        headers {
          name
          type
          align
          value
        }
        total {
          spendingCategory
          fyFourYearsAgo
          fyThreeYearsAgo
          fyTwoYearsAgo
          fyOneYearsAgo
          fyHouse
        }
        data {
          spendingCategory
          fyFourYearsAgo
          fyThreeYearsAgo
          fyTwoYearsAgo
          fyOneYearsAgo
          fyHouse
        }
      }
      # Get the last modified timestamp for the file powering the line item pages
      ...LineItemDataTimeStamp
    }
  }
`;
